import { GetMerchType as ApiMerchType } from 'src/api/generated/touring/types';
import { mapCompanyContactType } from '../../../common';
import { MerchType } from '../../types';

export const mapMerchType = (apiType: ApiMerchType): MerchType => {
  return {
    rate: apiType.rate,
    contact: apiType.contact ? mapCompanyContactType(apiType.contact) : null,
    notes: apiType.notes,
  };
};
